import { render, staticRenderFns } from "./ModalManageRouteUsers.vue?vue&type=template&id=0b474148"
import script from "./ModalManageRouteUsers.vue?vue&type=script&lang=js"
export * from "./ModalManageRouteUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports